import { Directive } from "@angular/core";
import { CameraHelperService } from "../../services/camera-helper.service";
import { CesiumMapService } from "../../services/cesium-map.service";
import { CoordinateConverter } from "../../services/coordinate-converter/coordinate-converter.service";
import { CesiumPointerManagerService } from "../../services/pointer-manager/cesium-pointer-manager.service";
import { DtmMapEventsManagerService } from "../../services/pointer-manager/map-events-manager.service";
import { ThrottledCesiumEventBuilder } from "../../services/pointer-manager/throttled-cesium-event-builder";

export const DTM_CESIUM_MAP_PROVIDERS = [
    CesiumMapService,
    DtmMapEventsManagerService,
    ThrottledCesiumEventBuilder,
    CameraHelperService,
    CesiumPointerManagerService,
    CoordinateConverter,
];

@Directive({
    selector: "[dtmMapCesiumMapProviders]",
    providers: DTM_CESIUM_MAP_PROVIDERS,
})
export class CesiumMapProvidersDirective {}
